<template>
  <div class="flex column" >
    <HeaderCard :title="$t('CMSProduct.products')" :showAddButton="false" @open="openProductEditor"></HeaderCard>
    <el-row class="mb-10 mt-0">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <span v-if="selected.length==0 && !isFiltered" class="fs-14">Tous les produits <span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{count}}</span></span>
        <span v-else>
          <span class="fs-14">Produits</span>
          <span v-if="selected.length > 0">
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> Sélectionné(s)</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{selected.length}}</span>
            <el-dropdown size="small" split-button type="primary" class="ml-20">
              Actions
              <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="handleUnpublish(true)"><i class="el-icon-success"></i>Publier</el-dropdown-item>
               <el-dropdown-item @click.native="handleUnpublish(false)"><i class="el-icon-error"></i>Dépublier</el-dropdown-item>
               <el-dropdown-item :disabled="true"><i class="mdi mdi-file-excel"></i>Exporté CSV</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span v-if="isFiltered && selected.length == 0">
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> Résultats de recherche</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{count}}</span>
          </span>
        </span>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <el-input
          size="small"
          placeholder="Rechercher un produit"
          clearable
          v-model="searchModel"
          v-popover:popover>

          <el-button
            slot="prepend"
            @click="showFilters=true">
            <i class="mdi mdi-filter-variant" style="font-size:15px;">
              <span v-if="activeFilters > 0">{{activeFilters}}
                <span class="hidden-md-and-down">
                  <span v-if="activeFilters==1">filtre</span>
                  <span v-else>filtres</span>
                  <span v-if="activeFilters==1"> appliqué</span>
                  <span v-else> appliqués</span>
                </span>
                <el-link type="info" @click="handleReset" class="ml-2">
                  <i class="mdi mdi-filter-remove"/>
                </el-link>
              </span>
              <span v-else class="secondary-text fs-14"> <span class="hidden-md-and-down">Filtres avancés</span></span>
            </i>
          </el-button>
        </el-input>
      </el-col>
    </el-row>
    <div class="flex center m-10">
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="pages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <el-table
      border
      :data="products"
      stripe
      v-loading="loading"
      @selection-change="handleSelectionChange"
      empty-text="Aucun produit"
      height="100%"
      style="width: 100%">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column type="expand">
      <template slot-scope="props">
        <CmsProductItemTable :cmsProductItems="props.row.items" />
      </template>
    </el-table-column>
    <el-table-column
      resizable
      show-overflow-tooltip
      label="name">
      <template slot-scope="scope">
        <PortausLink :id="scope.row.id" path="/settings/CMS/products/" :label="scope.row.cmsName || scope.row.name"></PortausLink>
        <span class="fs-12 secondary-text">
          <br>
          <UnitFormatVolumeLabel
            :unit="scope.row.unit"
            :uvc="scope.row.uvc"
            :format="scope.row.format"
            :volume="scope.row.volume" />
        </span>
      </template>
    </el-table-column>
    <el-table-column
      show-overflow-tooltip
      resizable
      label="Producteur">
      <template slot-scope="scope">
        <PortausLink v-if="scope.row.cmsProvider != null" :id="scope.row.cmsProvider.id" path="/settings/CMS/providers/" :label="scope.row.cmsProvider.name"></PortausLink>
        <span v-else>
          <span v-if="scope.row.provider != null">
            <CustomerProviderName
              :name="scope.row.provider.name"
              :usualName = "scope.row.provider.usualName" />
            </span>
        </span>
      </template>
    </el-table-column>
    <el-table-column
     show-overflow-tooltip
     resizable
      label="Type">
      <template slot-scope="scope">
        <span v-if="scope.row.specificCategory != null">
          <span>{{scope.row.category.name}} - {{scope.row.specificCategory.name}}</span>
        </span>
        <span v-else> -- </span>
      </template>
    </el-table-column>
    <el-table-column
      show-overflow-tooltip
      resizable
      label="Compagnies">
      <template slot-scope="scope">
        <span v-if="scope.row.portausCompanies && scope.row.portausCompanies.length > 0">
          <el-tag
            v-for="pc in scope.row.portausCompanies"
            :key="pc.id"
            size="mini"
            class="mr-5">
            {{ getPortausCompanyName(pc.id) }}
          </el-tag>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="published"
      resizable
      align="center"
      width="90"
      label="Publié">
      <template slot-scope="scope">
        <i v-if="scope.row.published" class="accent-text el-icon-success"></i>
        <i v-else class="el-icon-error"></i>
      </template>
    </el-table-column>
    <el-table-column
      resizable
      align="center"
      width="100"
      label="Image principale">
      <template slot-scope="scope">
        <span v-if="scope.row.image != null">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <slot name="content">
              <el-image
                :src="scope.row.image.thumbnailLink"
                fit="contain">
              </el-image>
            </slot>
            <i slot="reference" class="fs-18 accent-text mdi mdi-image-search-outline"> </i>
          </el-popover>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      resizable
      align="center"
      width="100"
      label="Fiche(s)">
      <template slot-scope="scope">
        <span v-if="scope.row.items != null">{{ scope.row.items.length }}</span>
      </template>
    </el-table-column>
    <el-table-column
      resizable
      align="center"
      width="180"
      label="Atributs">
      <template slot-scope="scope">
        <span v-for="(att, index) in scope.row.attributes">
          <br v-if="index>=1">
          {{getAttributesValue(att)}}
        </span>
      </template>
    </el-table-column>
    <!-- <el-table-column
      resizable
      sortable
      align="center"
      width="100"
      label="Qty">
      <template slot-scope="scope">
        <span v-if="scope.row.erpProduct != null && scope.row.erpProduct.quantity != null">
          {{scope.row.erpProduct.quantity.available}}
          <span v-if="scope.row.erpProduct.quantity.pending != null && scope.row.erpProduct.quantity.pending > 0">
            -> {{scope.row.erpProduct.quantity.pending}}
          </span>
        </span>
      </template>
    </el-table-column> -->
  </el-table>
  <WaitingDialog :content="waitingContent" :visible="waitingDialogVisible" :title="waitingTitle"></WaitingDialog>
  <ProductFilter
    :visible="showFilters"
    @close="showFilters=false"
    @filtersChange="handleFiltersChange"
    />
  </div>
</template>
<script>
import cmsAPI from '@/services/API/cmsAPI'
import productAPI from '@/services/API/product'
import HeaderCard from '@/components/header-card'
import moment from 'moment-timezone'
import PortausLink from '@/components/portaus-link'
import Promise from 'bluebird'
import { mapActions, mapState, mapGetters } from 'vuex';
import Pagination from '@/components/pagination'
import CmsProductItemTable from './components/cms-product-item-table'
import WaitingDialog from '@/components/waiting-dialog'
import CustomerProviderName from '@/components/customer-provider-name'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import ProductFilter from '@/views/pages/settings/inventories/components/product-filter'
export default {
	name: 'Products',
	data() {
		return {
      selected: [],
      waitingDialogVisible: false,
      showFilters: false,
      activeFilters : 0,
		}
	},
  components: {
    HeaderCard,
    PortausLink,
    Pagination,
    CmsProductItemTable,
    WaitingDialog,
    CustomerProviderName,
    UnitFormatVolumeLabel,
    ProductFilter
  },
  computed: {
    handleShowFilters () {
      this.showFilters = true;
    },
    portausCompanies() {
      return this.$store.state.controlData.portausCompanies || [];
    },
    waitingContent () {
      return "Opération en cours..."
    },
    waitingTitle () {
      return "Veuillez patientez";
    },
    searchModel : {
      set(val){ this.setSearchTerms({ searchTerms :val, params: { type: 1 }})},
      get(){ return this.searchTerms }
    },
    ...mapState('products', ['products','loading','page','pages','limit', 'count','searchTerms']),
    ...mapGetters('products',['isFiltered']),
    ...mapGetters('inventoryProducts', ['getNbFiltersCriteria'])
  },
  methods : {
    getPortausCompanyName(id) {
      const pc = _.find(this.portausCompanies, c => c.id === id);
      return pc ? pc.name : id;
    },
    handleFiltersChange (filtersObj) {
      this.activeFilters = _.get(filtersObj, 'activeFilters');
    },
    handleUnpublish (published) {
      this.waitingDialogVisible = true;
      return Promise.each(this.selected, (p) => {
        this.productLoading = true;
        let postData = {
          published,
          publishedDate: new moment().format(),
          lockVersion: p.lockVersion,
        };

        const productIdToUpdate = p.id;
        return productAPI.updateProductV2(p.id, postData)
      })
      .then(()=> {
        this.refreshProducts();
        this.waitingDialogVisible = false;
      })
      .catch((err) => {
        console.log(err);
        this.waitingDialogVisible = false;
      })
    },
    getAttributesValue(attribut) {
      return attribut.type.name + ' : ' + attribut.value;
    },
    deleteSelectedProducts(){
      this.$confirm('Êtes vous sûr de vouloir supprimer les produits sélectionnés?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(()=>{
          this.waitingDialogVisible = true;
          return Promise.each(this.selected, p=>{
            return cmsAPI.deleteProduct(p.id);
          })
          .then(()=> {
            this.$message.success("Le ou les produits ont été supprimés avec succès!");
            this.waitingDialogVisible = false;
          })
          .then(()=>this.refreshProducts())
        })
        .catch(err=>{
          if(err=="cancel"){
            this.$message('Suppression annulée!');
          }else{
            console.log(err);
            this.waitingDialogVisible = false;
            this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
          }
        })
    },
    _moment(datetime, format='l'){
      return moment(datetime).format(format);
		},
    openProductEditor(){
      this.$router.push('/CMS/product');
    },
    refreshProducts(){
      this.invalidateList();
      return this.fetchProducts({ type: 1 });
    },
    handleSelectionChange(val){
      this.selected = val;
    },
    handleReset(event) {
      if(event != null) {
        event.stopPropagation();
      }
      this.resetProductFilters();
    },
  	...mapActions('products',['setOrigin','setActiveFilter','resetProductFilters','fetchProducts','fetchPreviousPage', 'fetchNextPage', 'productFilters','setSearchTerms','updateProduct', 'setPublishProduct', 'setExtendedObject', 'invalidateList']),
    ...mapActions('controlData', ['fetchPortausCompany']),
  },
  mounted(){
    this.setOrigin('CMS');
    this.setExtendedObject(['items']);
    this.fetchPortausCompany();
    return this.refreshProducts();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';


</style>
